import type { Route } from "../../../../../utils/models/Route";
import type { PlanTrailState } from "../../modules/PlanTrailModule";
import type { UndoCommand, CommandContext } from "../types";

/**
 * Command for a guided-mode day-count re-split. A day-count change can
 * replace an arbitrary number of routes at once (every main-line leg gets
 * rebuilt from the re-sliced master trail), so — like MergeAllRoutesCommand —
 * this snapshots the whole routes map wholesale rather than trying to invert
 * the slice algebraically.
 */
export class ApplyDayCountCommand implements UndoCommand {
  readonly type = 'APPLY_DAY_COUNT';
  readonly routeKey: string | null = null;

  private routesBefore: { [key: string]: Route };
  private routesAfter: { [key: string]: Route };
  private activeRouteKeyBefore: string | null;
  private activeRouteKeyAfter: string | null;
  private dayInfoBefore: PlanTrailState['dayInfo'];
  private dayInfoAfter: PlanTrailState['dayInfo'];

  constructor(data: {
    routesBefore: { [key: string]: Route };
    routesAfter: { [key: string]: Route };
    activeRouteKeyBefore: string | null;
    activeRouteKeyAfter: string | null;
    dayInfoBefore: PlanTrailState['dayInfo'];
    dayInfoAfter: PlanTrailState['dayInfo'];
  }) {
    this.routesBefore = JSON.parse(JSON.stringify(data.routesBefore));
    this.routesAfter = JSON.parse(JSON.stringify(data.routesAfter));
    this.activeRouteKeyBefore = data.activeRouteKeyBefore;
    this.activeRouteKeyAfter = data.activeRouteKeyAfter;
    this.dayInfoBefore = JSON.parse(JSON.stringify(data.dayInfoBefore));
    this.dayInfoAfter = JSON.parse(JSON.stringify(data.dayInfoAfter));
  }

  undo(ctx: CommandContext): void {
    ctx.state.routes = JSON.parse(JSON.stringify(this.routesBefore));
    ctx.state.activeRouteKey = this.activeRouteKeyBefore;
    ctx.state.dayInfo = JSON.parse(JSON.stringify(this.dayInfoBefore));
    ctx.state._statsVersion++;
  }

  redo(ctx: CommandContext): void {
    ctx.state.routes = JSON.parse(JSON.stringify(this.routesAfter));
    ctx.state.activeRouteKey = this.activeRouteKeyAfter;
    ctx.state.dayInfo = JSON.parse(JSON.stringify(this.dayInfoAfter));
    ctx.state._statsVersion++;
  }
}
